<!--
<div [formGroup]="form">
	 <nz-form-item *ngSwitchCase="'File'">
		<nz-form-label [nzSpan]="6"  [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-control [nzSpan]="14">
			<input type="file" (change)="onFileSelected($event, wrapper)" />
		</nz-form-control>
	</nz-form-item>
</div>
-->
<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required" nzFor="{{ toControlKey(wrapper.element) }}">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required" nzFor="{{ toControlKey(wrapper.element) }}">{{ wrapper.element.name }}</nz-form-label>


		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<!-- TODO make it readonly -->
			 <div class="row">
				<div class="col">
					<nz-upload
						[nzDisabled]="readonly"
						nzListType="text"
						[nzMultiple]="false"
						[nzFileList]="fileList"
						[nzCustomRequest]="customUpload"
						(nzRemove)="onRemove()">
						<button nz-button *ngIf="!readonly">
							<span *ngIf="!wrapper.control.valid || !wrapper.control.value" nz-icon nzType="upload"></span>
							<span *ngIf="wrapper.control.valid && wrapper.control.value" nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
							<span *ngIf="!wrapper.control.valid || !wrapper.control.value">Click to Upload</span>
							<span *ngIf="wrapper.control.valid && wrapper.control.value">Uploaded</span>
						</button>
						<button nz-button *ngIf="readonly">Upload Disabled</button>
					</nz-upload>
				</div>
				<div class="col">
					<button [disabled]="!wrapper.control.valid" nz-button nzSize="small" [nzType]="'dashed'" (click)="doPreviewFile()" class="me-2">
						<span nz-icon nzType="eye"></span>
					</button>
					<button [disabled]="!wrapper.control.valid" nz-button nzSize="small" [nzType]="'dashed'" (click)="doDownloadFile()" class="me-2">
						<span nz-icon nzType="download"></span>
					</button>
				</div>
			 </div>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<!-- TODO make it readonly -->
			 <div class="row">
				<div class="col">
					<nz-upload
						[nzDisabled]="readonly"
						nzListType="text"
						[nzMultiple]="false"
						[nzFileList]="fileList"
						[nzCustomRequest]="customUpload"
						(nzRemove)="onRemove()">
						<button nz-button *ngIf="!readonly">
							<span *ngIf="!wrapper.control.valid || !wrapper.control.value" nz-icon nzType="upload"></span>
							<span *ngIf="wrapper.control.valid && wrapper.control.value" nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
							<span *ngIf="!wrapper.control.valid || !wrapper.control.value">Click to Upload</span>
							<span *ngIf="wrapper.control.valid && wrapper.control.value">Uploaded</span>
						</button>
						<button nz-button *ngIf="readonly">Upload Disabled</button>
					</nz-upload>
				</div>
				<div class="col">
					<button [disabled]="!wrapper.control.valid" nz-button nzSize="small" [nzType]="'dashed'" (click)="doPreviewFile()" class="me-2">
						<span nz-icon nzType="eye"></span>
					</button>
					<button [disabled]="!wrapper.control.valid" nz-button nzSize="small" [nzType]="'dashed'" (click)="doDownloadFile()" class="me-2">
						<span nz-icon nzType="download"></span>
					</button>
				</div>
			</div>
		</nz-form-control>
	</nz-form-item>
</div>
